import React from "react"
import { Navigate } from "react-router-dom"
import { VirtualCastOAuthAccessTokenForm } from "../component/oauth/VirtualCastOAuthAccessTokenForm"
import { useAccessContext } from "../component/guard/AccessGuard"
import { Paths } from "../paths"

export const OAuthVirtualCastCallback = () => {
  const params = new URLSearchParams(window.location.search)
  const code = params.get("code")
  const state = params.get("state")
  const context = useAccessContext()
  const { credential } = context

  if (code === null || state === null) {
    console.warn(`code and/or state are null! code: ${code}, state: ${state}`)
    return <Navigate to={Paths.top.path} />
  }

  return (
    <div className="row">
      <div className="col-12 d-flex flex-column align-items-center gap-3 mt-5">
        <h3>OAuth Callback</h3>

        <div className="text-center" style={{ wordBreak: "break-all" }}>
          <h4>Code</h4>
          <span>{code}</span>
          <h4>State</h4>
          <span>{state}</span>
        </div>

        <div>
          <h4>Generate Access code</h4>
          <VirtualCastOAuthAccessTokenForm firebase={credential.user} code={code} state={state} />
        </div>
      </div>
    </div>
  )
}
